export const INVALID_PWD = 101
